const _allMensagens = [
	{
		val: 'CRITERIO DE CONTRAPARTIDA',
		text: 'Critérios de Contrapartida (Curta negociação inicial)',
		departamento: '1',
		mensagens: [
			`Conteúdos dentro dos padrões SEO, com 4 links, de 700 a 800 palavras conforme o nicho do seu site..`
		]
	},
	{
		val: 'CRITERIOS DE CONTRAPARTIDA LONGA',
		text: 'Critérios de Contrapartida longa',
		departamento: '2',
		mensagens: [
			`Leitura dinâmica;

			Evitar definições superficiais; 
			
			Texto precisa ter introdução, no mínimo dois h2, tópico com ao menos 4 itens e conclusão (de preferência com um h2 que chame atenção às considerações finais); 
			
			Quantidade de Palavras: 500 / 600 palavras; 
			
			O conteúdo pode ter até 3 links externos; 
			
			Conteúdo deve ser informativo e não conter nenhuma alusão comercial; 
			
			As informações precisam ser passadas de maneira simples, ilustrando exemplos, analogias ou apresentando dados, se necessário; 
			
			É necessário também que haja uma distância de 50 palavras entre um link e outro, para não prejudicar as estratégias de SEO do conteúdo; 
			
			Os links também devem aparecer de forma sutil, sem deixar explícito ao leitor que ele está sendo direcionado para uma determinada página; 
			
			Não devem conter Call To Action (CTA); 
			
			Informar a Palavra-Chave / Meta-Título / Meta-Descrição; 
			
			Os links do conteúdo devem ser referentes ao blog de parceria ativada; 
			
			O conteúdo deve ser enviado no mês vigente da negociação.`
		]
	},
	{
		val: 'SUGESTAO PRONTA DE ENVIO DE PAUTA',
		text: 'Sugestão pronta de envio de pauta',
		departamento: '3',
		mensagens: [
			`Seguem as nossas sugestões de pautas para este mês:
			Pautas;
			Pautas;
			Pautas;
			Todos os nossos conteúdos são produzidos dentro desses critérios(DOC).
			Esses critérios também são aplicados aos conteúdos que recebemos como contrapartida.`
		]
	},
	{
		val: 'SUGESTAO DE LEMBRETE DE DEADLINE DE PUBLICACAO',
		text: 'Sugestão de lembrete de deadline de publicação ',
		departamento: '4',
		mensagens: [
			`Olá [Nome do Contato]! Como você está?

			Estou entrando em contato para reforçar que nosso prazo para a publicação se aproxima, com a data agendada para o dia XX/XX.
			
			Caso surja algum imprevisto ou questionamento, fique à vontade para me informar. A troca de informações é fundamental para garantir que nossa parceria continue evoluindo com sucesso :)`
		]
	}
];

const getMensagens = () => _allMensagens;

module.exports = {
	getMensagens
}
